module.exports = __webpack_public_path__ + "app-static/img/withdrawalBg.2c82f0f8.png";